export const saveAuth = (token: string, user: any) => {
  sessionStorage.setItem('sessionId', token);
  sessionStorage.setItem('user', JSON.stringify(user));
};

export const getSessionId = () => {
  return sessionStorage.getItem('sessionId');
};

export const saveSessionId = (sessionId: string) => {
  sessionStorage.setItem('sessionId', sessionId);
};


export const clearAuth = () => {
  //sessionStorage.removeItem('sessionId');
  sessionStorage.removeItem('user');
};
